import errorHandler from './errorHandler';
import initRequest from './initRequest';

function filenameFromContentDisposition(disposition) {
  if (!disposition) {
    return '';
  }

  const match = /filename\*\s*=\s*UTF-8''([^;]+)|filename\s*=\s*"([^"]+)"|filename\s*=\s*([^;]+)/i.exec(
    disposition
  );

  if (!match) {
    return '';
  }

  return decodeURIComponent((match[1] || match[2] || match[3] || '').trim());
}

class FileClient {
  download(url) {
    return fetch(url, initRequest({ method: 'GET' }))
      .then(response => {
        const type = response.headers.get('content-type') || '';
        if (!response.ok || type.includes('application/json')) {
          throw { code: response.status, message: response.statusText || 'Download failed' };
        }

        const filename = filenameFromContentDisposition(
          response.headers.get('content-disposition')
        );

        return response.blob().then(blob => ({ blob, filename }));
      })
      .then(({ blob, filename }) => {
        const objectUrl = URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = objectUrl;
        anchor.download = filename || 'download.pdf';
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        URL.revokeObjectURL(objectUrl);
      })
      .catch(error => errorHandler.handle(error));
  }
}

export default new FileClient();
